const path = '$mail';

export const EMAIL_CURRENT = `${path}/email/current`;
export const EMAIL_SELECT = `${path}/emailSelect`;
export const EMAIL_SELECT_ALL = `${path}/email/select/all`
export const EMAIL_SELECT_CLEAR = `${path}/email/select/clear`
export const EMAIL_DETAIL = `${path}/email/detail`;
export const FOLDER_LOAD = `${path}/folders/load`;
export const FOLDER_LIST = `${path}/folders/list`;